var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"px-4",attrs:{"fluid":"","id":"container"}},[_c('b-row',[_c('b-col',{staticClass:"pb-2",attrs:{"id":"countdown-title","cols":"12"}},[_c('h1',[_vm._v("ALL ABOARD THE GEFILTE SHIP!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }